import { useContext, useEffect, useState, useMemo } from "react";
import { DasboardContext } from "../../context/dashboard-context";
import { useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Button } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { autoTable } from "jspdf-autotable";
import { jsPDF } from "jspdf";

import "./style.css";
import ChartComponent from "../Chart/Chart";
import EventChart from "../EventChart/EventChart";

const VitalDetail = () => {
  const { sidebarOpen, bedData } = useContext(DasboardContext);
  const { id } = useParams();
  const [events, setEvents] = useState([]);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("tr-TR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const [statues, setStatues] = useState(null);
  const [startDatetime, setStartDatetime] = useState("");
  const [endDatetime, setEndDatetime] = useState("");
  const [residentId, setResidentId] = useState("");
  const [profile, setProfile] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [thisDevice, setThisDevice] = useState([]);

  useEffect(() => {
    if (!bedData || bedData.length === 0) return;

    const found = bedData.find((item) => item.deviceID === id);
    setThisDevice(found);
  }, [bedData, id]);

  const fetchResidentId = async (token) => {
    const url = `https://eu.vitalerter.com/api/v1/devices/${id}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setResidentId(data?.resident?.id);
    } catch (error) {
      console.error("Error fetching resident id:", error);
    }
  };

  const fetchVitals = async (token) => {
    const params = new URLSearchParams({
      startDatetime,
      endDatetime,
      allParameters: true,
    });

    const url = `https://eu.vitalerter.com/api/v1/reports/vitals/${residentId}?${params.toString()}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Vitals", data);
      const filteredEvents = data?.items.filter(
        (item) => (item?.occupancy && item.time) || item?.type === "alert"
      );
      setEvents(filteredEvents);
      console.log("değişiklikler", filteredEvents);
      setStatues(data);
    } catch (error) {
      console.error("Error fetching devices:", error);
    }
  };

  const fetchProfiles = async (token) => {
    const params = new URLSearchParams({
      startDatetime,
      endDatetime,
      allParameters: true,
    });

    const url = `https://eu.vitalerter.com/api/v1/reports/profile/${residentId}?${params.toString()}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setProfile(data);
    } catch (error) {
      console.error("Error fetching devices:", error);
    }
  };

  useEffect(() => {
    const authenticateAndFetch = async () => {
      const jwtToken =
        "/9m2n37CxCoGq9wVW1Sm1+tMsZHhPgPoay2eESkrPpY28apaCXhP1yCQY9fhks4H";
      const url =
        "https://eu.vitalerter.com/api/v1/organizations/apiaccess/authenticate";

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({ apiKey: jwtToken }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data) {
          await fetchResidentId(data);
          await fetchVitals(data);
          await fetchProfiles(data);
        }
      } catch (error) {
        console.error("Error during authentication:", error);
      }
    };

    authenticateAndFetch();
  }, [startDatetime, endDatetime]);

  const filteredUniqueHourlyData = useMemo(() => {
    if (!statues) return [];

    const uniqueHourlyData = [];
    const addedHours = new Set();

    statues.items.forEach((item) => {
      const date = new Date(item.time);
      const hourKey =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours();

      if (!addedHours.has(hourKey)) {
        uniqueHourlyData.push(item);
        addedHours.add(hourKey);
      }
    });

    return uniqueHourlyData;
  }, [statues]);

  const totalPages = useMemo(() => {
    return Math.ceil(filteredUniqueHourlyData.length / itemsPerPage);
  }, [filteredUniqueHourlyData]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return filteredUniqueHourlyData.slice(startIndex, endIndex);
  }, [currentPage, filteredUniqueHourlyData]);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const convertToCSV = (data) => {
    const allHeaders = data.reduce((acc, item) => {
      Object.keys(item).forEach((key) => {
        if (!acc.includes(key)) acc.push(key);
      });
      return acc;
    }, []);

    const rows = data.map((item) =>
      allHeaders.map((header) => item[header] || "").join(",")
    );

    return [allHeaders.join(","), ...rows].join("\n");
  };

  const downloadCSV = () => {
    const csv = convertToCSV(statues.items);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const downloadPDF = () => {
    if (!statues || !statues.items) return;

    const doc = new jsPDF("l", "pt", "a4");
    doc.setFontSize(14);
    doc.text("Vital Verileri", 40, 40);

    const tableColumn = [
      "Zaman",
      "HR",
      "RR",
      "HRV",
      "SV",
      "Hareket",
      "Rahatlık",
      "Yakındaki Kullanıcılar",
    ];

    const tableRows = statues.items.map((item) => [
      formatDate(item.time),
      item.hr ?? "-",
      item.rr ?? "-",
      item.hrv ?? "-",
      item.sv ?? "-",
      item.movement ?? "-",
      item.relax ?? "-",
      item.usersNearby && item.usersNearby.length > 0
        ? item.usersNearby.join(", ")
        : "Boş",
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 60,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save("vital-verileri.pdf");
  };

  return (
    <>
      <Breadcrumb />
      <div
        className={`device-wrapper component-wrapper ${
          sidebarOpen ? "" : "close"
        }`}
      >
        <div className="vital-info">
          <p>
            Oda Adı: <strong>{thisDevice.roomName}</strong>
          </p>
          <p>|</p>
          <p>
            Süit Adı: <strong>{thisDevice.suiteName}</strong>
          </p>
        </div>
        <div className="date-picker-container">
          <div>
            <label>Başlangıç Tarihi:</label>
            <Form.Control
              type="date"
              value={startDatetime.slice(0, -1)}
              onChange={(e) => setStartDatetime(e.target.value + "Z")}
            />
          </div>

          <div>
            <label>Bitiş Tarihi:</label>
            <Form.Control
              type="date"
              value={endDatetime.slice(0, -1)}
              onChange={(e) => setEndDatetime(e.target.value + "Z")}
            />
          </div>
        </div>

        <div className="download-wrapper">
          <Button className="download-btn" onClick={downloadCSV}>
            Verileri İndir (Excel)
          </Button>
          <Button className="download-btn" onClick={downloadPDF}>
            Verileri İndir (PDF)
          </Button>
        </div>

        <Tabs
          defaultActiveKey="home"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="home" title="Vital Değerler">
            {profile && paginatedData && (
              <ChartComponent data={statues.items} />
            )}

            {statues ? (
              <>
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="alarm-table"
                >
                  <thead>
                    <tr>
                      <th>Zaman</th>
                      <th>HR</th>
                      <th>RR</th>
                      <th>HRV</th>
                      <th>SV</th>
                      <th>Hareket</th>
                      <th>Rahatlık</th>
                      <th>Yakındaki Kullanıcılar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item, index) => (
                      <tr key={index}>
                        <td>{formatDate(item.time)}</td>
                        <td>{item.hr}</td>
                        <td>{item.rr}</td>
                        <td>{item.hrv}</td>
                        <td>{item.sv}</td>
                        <td>{item.movement}</td>
                        <td>{item.relax}</td>
                        <td>
                          {item.usersNearby.length > 0
                            ? item.usersNearby.join(", ")
                            : "Boş"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <div className="pagination-controls">
                  <Button
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Önceki
                  </Button>
                  <span>
                    {currentPage} / {totalPages}
                  </span>
                  <Button
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Sonraki
                  </Button>
                </div>
              </>
            ) : (
              <p>Lütfen tarih aralığı seçiniz...</p>
            )}
          </Tab>
          <Tab eventKey="profile" title="Alarm Bilgileri">
            <EventChart data={profile.items} />
            {statues ? (
              <>
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="alarm-table"
                >
                  <thead>
                    <tr>
                      <th>Zaman</th>
                      <th>Olay Türü</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((item, index) => (
                      <tr key={index}>
                        <td>{formatDate(item.time)}</td>
                        <td>
                          {item.occupancy === "inBed"
                            ? "Yatağa Girdi"
                            : item.occupancy === "outOfBed"
                            ? "Yataktan Çıktı"
                            : !item.occupancy && item.title === "Posture Change"
                            ? item.details ===
                              "Turn left to prevent pressure ulcers"
                              ? "Bası yaralarını önlemek için pozisyon verin"
                              : item.details ===
                                "Turn to back to prevent pressure ulcers"
                              ? "Bası yaralarını önlemek için pozisyon verin"
                              : item.details ===
                                "Turn right to prevent pressure ulcers"
                              ? "Bası yaralarını önlemek için pozisyon verin"
                              : item.details
                            : item.occupancy}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            ) : (
              <p>Lütfen tarih aralığı seçiniz...</p>
            )}
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default VitalDetail;
